angular.module('impactx.address').service('BasketAddressSelectionPanel', [
    '$mdPanel',
    '$q',
    BasketAddressSelectionPanel]);

function BasketAddressSelectionPanel($mdPanel, $q) {
    var self = this;
    var panelRef, defer, locals, transferData;

    self.openPanel = function (config) {
        if (config) {
            defer = $q.defer();
            locals = config.locals || {};

            var panelConfig = {
                attachTo: angular.element(document.body),
                controller: 'BasketAddressSelectionPanelCtrl',
                controllerAs: 'ctrl',
                zIndex: 79,
                locals: {
                    config: config
                },
                animation: $mdPanel.newPanelAnimation().openFrom(config.event).closeTo('.' + config.targetElement).duration(100).withAnimation($mdPanel.animation.SCALE),
                position:  $mdPanel.newPanelPosition().relativeTo('.' + config.targetElement).addPanelPosition($mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.BELOW),
                panelClass: 'address-selection-panel',
                templateUrl: 'modules/address/templates/basket-address-selection.panel.html',
                clickOutsideToClose: config.clickOutsideToClose || true,
                escapeToClose: config.escapeToClose || true,
                focusOnOpen: config.focusOnOpen || true,
                onOpenComplete: function () {
                    setTimeout(function() {
                        angular.element('#' + config.data.addressType + 'Address').find('input').focus();
                    }, 500);
                }
            };

            $mdPanel.open(panelConfig).then(function (result) {
                panelRef = result;
            });

            return defer.promise;
        }
        else {
            console.log('no config for basket address selection service provided!')
        }
    };

    self.closePanel = function () {
        defer.resolve(transferData);
        transferData = {};
        panelRef.close().then(function () {
            panelRef.destroy();
        });
    };

    self.setSelection = function (entry) {
        if (entry) {
            transferData = entry;
        }
    };

    return {
        openPanel: this.openPanel,
        closePanel: this.closePanel,
        setSelection: this.setSelection,
    };
}